import Phaser from 'phaser';
import { SCENES } from '../constants';
import type { ResultsPayload } from '../../shared/types';
import { InputRouter } from './InputRouter';

class SceneRouterManager {
  private game: Phaser.Game | null = null;
  private currentScene: string = '';

  init(game: Phaser.Game): void {
    this.game = game;
  }

  private transition(from: string, to: string, data?: object): void {
    if (!this.game) {
      console.error('SceneRouter not initialized');
      return;
    }

    // Reset input state before scene change
    InputRouter.reset();

    const scene = this.game.scene.getScene(from);
    if (scene) {
      scene.scene.start(to, data);
      this.currentScene = to;
    }
  }

  getCurrentScene(): string {
    return this.currentScene;
  }

  setCurrentScene(scene: string): void {
    this.currentScene = scene;
  }

  // Navigation methods
  goToMenu(from: string): void {
    this.transition(from, SCENES.MENU);
  }

  goToSettings(from: string): void {
    this.transition(from, SCENES.SETTINGS, { returnTo: from });
  }

  goToMap(from: string): void {
    this.transition(from, SCENES.MAP);
  }

  goToGameplay(from: string, scenarioId: string): void {
    this.transition(from, SCENES.GAMEPLAY, { scenarioId });
  }

  goToResults(from: string, payload: ResultsPayload): void {
    this.transition(from, SCENES.RESULTS, { results: payload });
  }

  // Return to previous scene (for settings)
  returnToPrevious(from: string, returnTo: string): void {
    this.transition(from, returnTo);
  }

  // Restart current gameplay
  restartGameplay(from: string, scenarioId: string): void {
    this.transition(from, SCENES.GAMEPLAY, { scenarioId });
  }

  // Quick scene starts from BootScene
  startPreload(from: string): void {
    this.transition(from, SCENES.PRELOAD);
  }

  startMenu(from: string): void {
    this.transition(from, SCENES.MENU);
  }

  /** Hidden asset preview (only when URL has ?preview=assets) */
  startAssetPreview(from: string): void {
    this.transition(from, SCENES.ASSET_PREVIEW);
  }
}

// Singleton instance
export const SceneRouter = new SceneRouterManager();
